module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    staticClass: "notification-alert",
    attrs: {
      "color": _vm.type,
      "right": true,
      "top": true,
      "multi-line": true,
      "timeout": _vm.timeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_c('div', [(_vm.title) ? _c('div', {
    staticClass: "notification-alert-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "notification-alert-message"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showSnackbar = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ba607b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/Notification.vue
// module id = 561
// module chunks = 2